import { http } from 'utils'

import BaseStore from './BaseStore'

let state
export class Testing extends BaseStore {
  constructor() {
    super()
    this.observable({
      selected: '',
    })
    state = this
  }

  async redirect() {
    const url = `http://localhost:3200/mobile-auth/auth` // `${config.api}/mobile-auth/auth`
    const json = {}
    console.log('req:', json)
    const res = await http.post(url, { json })
    console.log('res:', res)
    return res
  }
}

export default new Testing()
